var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_c('div',{staticClass:"detail-body"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0","id":"bdIframes"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }